import { defineComponent as _defineComponent } from 'vue'
import bugsnagClient from '../../global/bugsnag';
import CompareSimilarProducts from './CompareSimilarProducts.vue';
import ProductService from "JS/services/ProductService";
import VIntersectionObserver from 'Src/js/components/VIntersectionObserver.vue';
import { computed, inject, PropType, ref, watch } from 'vue';
import { IListableProductJson } from 'JS/types/Product';
import { IPdpSimilarProduct } from 'JS/types/PDP';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyCompareSimilarCarousel',
  props: {
	currentProduct: {
		type: Object as PropType<IListableProductJson>,
		required: true
	}
},
  emits: ["add-to-cart"],
  setup(__props, { emit }: { emit: ({
	(event: 'add-to-cart'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const loading = ref(false);
const products = ref<IPdpSimilarProduct[]>([]);
const wasVisible = ref(false);

const productService = inject<ProductService>('productService');
async function loadCarouselData() {
	loading.value = true;
	wasVisible.value = true;

	try {
		const result: IPdpSimilarProduct[] = await productService.getSimilarProducts(props.currentProduct.blainNumber);
		if (!result) return;

		products.value = result;
	} catch (err) {
		bugsnagClient.notify(err);
		// eslint-disable-next-line no-console
		console.warn(err);
	}

	loading.value = false;
}

const { isMobile } = useBreakpoints();
const intersectionObserverOptions = computed((): IntersectionObserverInit => {
	const rootMargin = isMobile.value
		? '300px' // start loading a bit sooner on mobile
		: '100px';

	return {
		root: null,
		rootMargin,
	};
});

watch(() => props.currentProduct, () => {
	if (wasVisible.value) {
		loadCarouselData();
	}
});


return { __sfc: true,props, emit, loading, products, wasVisible, productService, loadCarouselData, isMobile, intersectionObserverOptions, CompareSimilarProducts, VIntersectionObserver }
}

})